import { IShowOn } from "../components/Interfaces";

/**
 * in compact event page we want to force render desktop view to show the sidebar of the complete event page
 */
export const evaluateRenderMobileView = ({
    showCompactEventPage,
    isMobileDeviceWidth,
}: {
    showCompactEventPage: boolean;
    isMobileDeviceWidth: boolean;
}) => (showCompactEventPage ? false : isMobileDeviceWidth);

export const evaluateHideComponent = ({
    showOn = "all",
    isMobile,
    hideComponent,
}: {
    showOn?: IShowOn;
    isMobile?: boolean;
    hideComponent?: boolean;
}) => {
    if (hideComponent) return true;

    if (showOn === "mobile" && !isMobile) return true;
    if (showOn === "desktop" && isMobile) return true;

    return false;
};
